import { Instant } from 'modules/graphql';

export enum EXPORT_DATA_TYPE {
  EMAIL_SEND = 'emailSend',
  EMAIL_OPEN = 'emailOpen',
  EMAIL_CLICK = 'emailClick',
  HOSTED_UNSUBSCRIBE_CLICK = 'hostedUnsubscribeClick',
  EMAIL_COMPLAINT = 'emailComplaint',
  EMAIL_BOUNCE = 'emailBounce',
  EMAIL_SEND_SKIP = 'emailSendSkip',
  PUSH_SEND = 'pushSend',
  PUSH_OPEN = 'pushOpen',
  PUSH_UNINSTALL = 'pushUninstall',
  PUSH_BOUNCE = 'pushBounce',
  PUSH_SEND_SKIP = 'pushSendSkip',
  IN_APP_SEND = 'inAppSend',
  IN_APP_OPEN = 'inAppOpen',
  IN_APP_CLICK = 'inAppClick',
  IN_APP_CLOSE = 'inAppClose',
  IN_APP_DELETE = 'inAppDelete',
  IN_APP_DELIVERY = 'inAppDelivery',
  IN_APP_SEND_SKIP = 'inAppSendSkip',
  IN_APP_RECALL = 'inAppRecall',
  INBOX_SESSION = 'inboxSession',
  INBOX_MESSAGE_IMPRESSION = 'inboxMessageImpression',
  SMS_SEND = 'smsSend',
  SMS_BOUNCE = 'smsBounce',
  SMS_CLICK = 'smsClick',
  SMS_RECEIVED = 'smsReceived',
  SMS_SEND_SKIP = 'smsSendSkip',
  WEB_PUSH_SEND = 'webPushSend',
  WEB_PUSH_CLICK = 'webPushClick',
  WEB_PUSH_SEND_SKIP = 'webPushSendSkip',
  EMAIL_SUBSCRIBE = 'emailSubscribe',
  EMAIL_UNSUBSCRIBE = 'emailUnSubscribe',
  PURCHASE = 'purchase',
  CUSTOM_EVENT = 'customEvent',
  USER = 'user',
  SMS_USAGE_INFO = 'smsUsageInfo',
  EMBEDDED_SEND = 'embeddedSend',
  EMBEDDED_SEND_SKIP = 'embeddedSendSkip',
  EMBEDDED_CLICK = 'embeddedClick',
  EMBEDDED_DISMISS = 'embeddedDismiss',
  EMBEDDED_RECEIVED = 'embeddedReceived',
  EMBEDDED_IMPRESSION = 'embeddedImpression',
  EMBEDDED_SESSION = 'embeddedSession',
}

export enum EXPORT_OUTPUT_FORMAT {
  JSON = 'application/x-json-stream',
  CSV = 'text/csv',
}

export enum EXPORT_FORM_FIELD {
  ORG_ID = 'organizationId',
  PROJECT_ID = 'projectId',
  OUTPUT_FORMAT = 'outputFormat',
  DATA_TYPE_NAME = 'dataTypeName',
  START_TIME = 'startDateTime',
  END_TIME = 'endDateTime',
  OMIT_FIELDS = 'omitFields',
  ONLY_FIELDS = 'onlyFields',
  CAMPAIGN_ID = 'campaignId',
  DELIMITER = 'delimiter',
}

export type ExportJobArgs = {
  [EXPORT_FORM_FIELD.ORG_ID]: number;
  [EXPORT_FORM_FIELD.PROJECT_ID]: number;
  [EXPORT_FORM_FIELD.OUTPUT_FORMAT]: string;
  [EXPORT_FORM_FIELD.DATA_TYPE_NAME]: string;
  [EXPORT_FORM_FIELD.START_TIME]?: Instant;
  [EXPORT_FORM_FIELD.END_TIME]?: Instant;
  [EXPORT_FORM_FIELD.OMIT_FIELDS]?: string;
  [EXPORT_FORM_FIELD.ONLY_FIELDS]?: string;
  [EXPORT_FORM_FIELD.CAMPAIGN_ID]?: number;
  [EXPORT_FORM_FIELD.DELIMITER]?: string;
};
